<template>
  <div>
    <!-- 数据统计列表 -->
    <div style="max-width: 100%">
      <div class="buttonList">
        <div
          class="item"
          v-for="(item, index) in buttonList"
          :key="index"
          :class="{ active: activeIndex === index }"
          @click="
            activeIndex = index;
            handleExtraClick(index);
          "
        >
          {{ item.name }}
        </div>
      </div>
      <div
        style="
          width: 100%;
          height: calc(100vh - 130px);
          overflow: hidden;
          overflow-y: auto;
          margin-top: 10px;
        "
      >
        <div
          v-for="(item, index) in questionList"
          :key="index"
          v-if="activeIndex === 0"
        >
          <div>
            <analysischart
              v-if="item.type === QuestionType.SCQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysischart
              v-if="item.type === QuestionType.MCQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysischart
              v-if="item.type === QuestionType.DLQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysistable
              v-if="item.type === QuestionType.SBQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysischart
              v-if="item.type === QuestionType.NPS"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysischart
              v-if="item.type === QuestionType.VOTE"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysistable
              v-if="item.type === QuestionType.SORT"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysischart
              v-if="item.type === QuestionType.SCORE"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysistable
              v-if="item.type === QuestionType.MBQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.QA"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.NAME"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysischart
              v-if="item.type === QuestionType.GENDER"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysischart
              v-if="item.type === QuestionType.AGE"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysistable
              v-if="item.type === QuestionType.TEL"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.EMAIL"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.DATE"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.TIME"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.ADDR"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysischart
              v-if="item.type === QuestionType.SRQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <wrqanalysischart
              v-if="item.type === QuestionType.WRQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </wrqanalysischart>
            <analysistable
              v-if="item.type === QuestionType.MaxDiff"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.UploadFile"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.DownloadFile"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.CASCADER"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.BDQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.IDQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysischart
              v-if="item.type === QuestionType.ELQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysistable
              v-if="item.type === QuestionType.WX"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.IMAGE"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.MatrixSCQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysistable
              v-if="item.type === QuestionType.MatrixMCQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysischart
              v-if="item.type === QuestionType.ImageSCQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysischart
              v-if="item.type === QuestionType.ImageMCQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysistable
              v-if="item.type === QuestionType.Signature"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
            <analysischart
              v-if="item.type === QuestionType.EvaluationSCQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysischart
              v-if="item.type === QuestionType.EvaluationMCQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysischart
              v-if="item.type === QuestionType.EvaluationWRQ"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysischart
              v-if="item.type === QuestionType.EvaluationNPS"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysischart
              v-if="item.type === QuestionType.EvaluationScore"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysischart>
            <analysistable
              v-if="item.type === QuestionType.TextDescription"
              :dataObj="item"
              :titleIndex="index"
            >
            </analysistable>
			<analysischart
			  v-if="item.type === QuestionType.TFQ"
			  :dataObj="item"
			  :titleIndex="index"
			>
			</analysischart>
			<analysistable
			  v-if="item.type === QuestionType.ClozeTest"
			  :dataObj="item"
			  :titleIndex="index"
			>
			</analysistable>
          </div>
        </div>
        <div class="dataAnalysis" v-if="activeIndex === 1">
          <el-table :data="tableData" style="width: 100%" header-align="center">
            <el-table-column
              type="index"
              label="序号"
              width="auto"
              align="left"
            >
            </el-table-column>
            <el-table-column
              prop="nickname"
              label="用户昵称"
              width="auto"
              align="center"
              class-name="custom-questionnaire-column"
            >
            </el-table-column>
            <!-- <el-table-column prop="recordsRate" label="答题进度" width="auto" align="left"
						class-name="custom-questionnaire-column">
						<template slot-scope="scope">
							{{ scope.row.recordsRate }}%
						</template>
					</el-table-column> -->
            <el-table-column
              prop="addTime"
              label="开始答题时间"
              width="auto"
              align="center"
              class-name="custom-questionnaire-column"
            >
              <template slot-scope="scope">
                {{ new Date(scope.row.addTime).toLocaleString() }}
              </template>
            </el-table-column>

            <el-table-column
              prop="endTime"
              label="答题结束时间"
              width="auto"
              align="center"
              class-name="custom-questionnaire-column"
            >
              <template slot-scope="scope">
                {{ new Date(scope.row.endTime).toLocaleString() }}
              </template>
            </el-table-column>

            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <span class="tableSpan" @click="handleUserDetail(scope.row)"
                  >用户详情</span
                >
                <span class="tableSpan" @click="handleSurveyDetail(scope.row)"
                  >问卷详情</span
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="queryParams.pageSize"
              :current-page="currentPage"
              :total="total"
              @current-change="handlePageChange"
            >
            </el-pagination>
          </div>
        </div>
        <div
          v-if="activeIndex === 2"
          style="width: 100%; padding: 24px; background-color: #ffffff"
        >
          <div style="display: flex; justify-content: flex-start">
            <div class="analysis-container">
              <!-- 自变量X部分 -->
              <div class="variable-section">
                <div class="section-header">
                  <h3 class="section-title">自变量X</h3>
                  <span class="section-limit">(仅限2道题)</span>
                </div>

                <div v-if="analysisList_x.length > 0" class="variable-list">
                  <div
                    v-for="(item, index) in analysisList_x"
                    :key="`x-${index}`"
                    class="variable-item"
                  >
                    <div
                      class="delete-btn"
                      @click="removeAnalysisVar('X', index)"
                    >
                      <p class="delete-icon"></p>
                    </div>
                    <span class="variable-text">{{ item.caseProblem }}</span>
                  </div>
                </div>
                <div
                  v-show="analysisList_x.length < 2"
                  class="add-div"
                  :style="{
                    borderTop:
                      analysisList_x.length > 0 ? 'none' : '1px solid #e8e8e8',
                  }"
                  @click="addAnalysisVar('X')"
                >
                  <div class="plus-icon">
                    <img
                      src="@/assets/images/add.svg"
                      alt=""
                      style="width: 8px; height: 8px"
                    />
                  </div>
                  <p class="add-text">添加自变量</p>
                </div>
              </div>

              <!-- 因变量Y部分 -->
              <div class="variable-section">
                <div class="section-header">
                  <h3 class="section-title">因变量Y</h3>
                  <span class="section-limit">(限10道题)</span>
                </div>

                <div v-if="analysisList_y.length > 0" class="variable-list">
                  <div
                    v-for="(item, index) in analysisList_y"
                    :key="`y-${index}`"
                    class="variable-item"
                  >
                    <div
                      class="delete-btn"
                      @click="removeAnalysisVar('Y', index)"
                    >
                      <p class="delete-icon"></p>
                    </div>
                    <span class="variable-text">{{ item.caseProblem }}</span>
                  </div>
                </div>

                <div
                  v-show="analysisList_y.length < 10"
                  class="add-div"
                  :style="{
                    borderTop:
                      analysisList_y.length > 0 ? 'none' : '1px solid #e8e8e8',
                  }"
                  @click="addAnalysisVar('Y')"
                >
                  <!-- <span class="plus-icon"><p>+</p></span> -->
                  <div class="plus-icon">
                    <img
                      src="@/assets/images/add.svg"
                      alt=""
                      style="width: 8px; height: 8px"
                    />
                  </div>
                  <p class="add-text">添加因变量</p>
                </div>
              </div>

              <!-- 生成分析按钮 -->
              <div style="display: flex">
                <button class="reset-btn" @click="resetAnalysis">重置</button>
                <button class="analyze-btn" @click="generateAnalysis">
                  生成交叉分析
                </button>
              </div>

              <!-- 模态框 -->
              <div v-if="showModal" class="modal-overlay" @click="closeModal">
                <div class="modal-content" @click.stop>
                  <h3>{{ modalTitle }}</h3>
                  <input
                    v-model="modalInput"
                    type="text"
                    placeholder="请输入变量名称"
                    @keyup.enter="confirmAdd"
                  />
                  <div class="modal-buttons">
                    <button class="btn-cancel" @click="closeModal">取消</button>
                    <button class="btn-confirm" @click="confirmAdd">
                      确认
                    </button>
                  </div>
                </div>
              </div>

              <!-- 结果显示 -->
              <div v-if="analysisResult" class="result-section">
                <h4>分析配置已生成：</h4>
                <p>{{ analysisResult }}</p>
              </div>
            </div>
            <div style="flex: 1; margin-left: 20px">
              <div v-for="(item, index) in chartOptions" :key="index">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div
                    style="
                      font-size: 16px;
                      font-weight: bold;
                      margin-left: 65px;
                    "
                  >
                    {{ index + 1 }}. {{ item.title }}
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: flex-end;
                      padding-right: 47px;
                    "
                  >
                    <div
                      v-for="icon in icons"
                      :key="icon.type"
                      style="width: 50px; height: 30px"
                      @click="
                        item.iconType = icon.type;
                        drawChart(icon, index);
                      "
                    >
                      <el-image
                        style="width: 50px; height: 30px"
                        :src="
                          icon.type === item.iconType
                            ? icon.selected
                            : icon.unselected
                        "
                        mode="aspectFit"
                        fit="fill"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="item.type === 'table'" style="margin-bottom: 20px">
                  <tableView :option="item"></tableView>
                </div>
                <div
                  v-else-if="item.type === 'line'"
                  style="margin-bottom: 20px"
                >
                  <chartLine
                    :id="item.id"
                    :option="item.option"
                    height="520px"
                    style="margin-top: 20px"
                  ></chartLine>
                </div>
                <div v-else style="margin-bottom: 20px">
                  <chartView
                    :id="item.id"
                    :option="item.option"
                    height="500px"
                  ></chartView>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :title="'用户详情'"
      :center="true"
      :modal="true"
      :close-on-click-modal="false"
      custom-class="my-custom-dialog"
      width="600px"
    >
      <!-- 完全自定义内容 -->
      <div class="dialog">
        <!-- <div class="titles">用户详情</div> -->
        <div class="profilePhoto">
          <img :src="dialogData.profilePhoto" alt="" />
        </div>
        <div class="item">
          <div class="subTitle">用户昵称</div>
          <div class="text">{{ dialogData.nickname }}</div>
        </div>
        <!-- <div class="item">
					<div class="subTitle">答题进度</div>
					<div class="text">{{ dialogData.recordsRate }}</div>
				</div> -->
        <div class="item">
          <div class="subTitle">开始答题时间</div>
          <div class="text">
            {{ new Date(dialogData.addTime).toLocaleString() }}
          </div>
        </div>
        <div class="item">
          <div class="subTitle">答题结束时间</div>
          <div class="text">
            {{ new Date(dialogData.endTime).toLocaleString() }}
          </div>
        </div>
        <button
          @click="
            dialogVisible = false;
            dialogConfirm();
          "
        >
          确定
        </button>
      </div>
      <div class="close" @click="dialogVisible = false"></div>
    </el-dialog>
    <div>
      <div class="coverShow" v-show="showAnalysis">
        <div class="container-gj" @click="showAnalysis = false">
          <div class="container-gd" @click.stop>
            <div class="header">
              <p>添加自变量X</p>
              <i
                class="fa-solid fa-circle-xmark"
                style="color: #8290a3; cursor: pointer"
                @click="showAnalysis = false"
              ></i>
            </div>
            <div style="max-height: 400px; overflow-y: auto">
              <div
                v-for="(item, index) in analysisList"
                :key="index"
                style="
                  display: flex;
                  align-items: center;
                  padding: 16px;
                  border-bottom: 1px solid #e7e7e7;
                "
              >
                <el-checkbox
                  v-model="item.isSelected"
                  :key="index"
                  @change="handleCheckboxChange($event, index)"
                  :disabled="item.disabled"
                ></el-checkbox>
                <p
                  style="
                    color: #323b5a;
                    font-size: 16px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: Regular;
                    margin-left: 10px;
                  "
                >
                  {{ item.caseProblem }}
                </p>
              </div>
            </div>
            <div class="analy-btn">
              <button class="analy-cancel" @click="showAnalysis = false">
                取消
              </button>
              <button class="analy-confirm" @click="confirmAddAnalysis">
                确认
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  questionAnalysis,
  questionnaireDataList,
  questionsAnalyList,
  crossAnalysis,
} from "@/api/index.js";
// import { QuestionType } from "@/components/constant.js";
import analysischart from "@/components/AnalysisChart.vue";
import analysistable from "@/components/AnalysisTable.vue";
import wrqanalysischart from "@/components/WRQAnalysisChart.vue";
import chartView from "@/components/crossAnalysis/chart.vue";
import chartLine from "@/components/crossAnalysis/chartLine.vue";
import tableView from "@/components/crossAnalysis/table.vue";

export default {
  components: {
    analysischart,
    analysistable,
    wrqanalysischart,
    chartView,
    chartLine,
    tableView,
  },
  data() {
    return {
      uuid: null,
      questionList: [],
      analysisList: [],
      QuestionType: this.$store.getters["questionType/getQuestionType"],
      buttonList: [
        {
          name: "题型分析",
          id: 0,
        },
        {
          name: "用户分析",
          id: 1,
        },
        {
          name: "交叉分析",
          id: 2,
        },
      ],
      activeIndex: 0,
      tableData: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userKey: "",
        questionnaireName: "",
        releaseStatus: "",
      },
      total: 0,
      currentPage: 1,
      dialogVisible: false,
      dialogData: {},
      // 交叉分析
      independentVars: [],
      dependentVars: [],
      showModal: false,
      modalInput: "",
      modalTitle: "",
      modalType: "",
      analysisResult: "",
      showAnalysis: false,
      analysisType: "",
      analysisList_x: [],
      analysisList_y: [],
      analysisDiasbled: false,
      chartOptions: [],
      icons: [
        {
          selected:
            "https://ossfastmake.mustke.com/qrCode/tupian/1763087218552.svg",
          unselected:
            "https://ossfastmake.mustke.com/qrCode/tupian/1763087166432.svg",
          type: "table",
        },
        {
          selected:
            "https://ossfastmake.mustke.com/qrCode/tupian/1744189110374.svg",
          unselected:
            "https://ossfastmake.mustke.com/qrCode/tupian/1744189084199.svg",
          type: "line",
        },
        {
          selected:
            "https://ossfastmake.mustke.com/qrCode/tupian/1744189145612.svg",
          unselected:
            "https://ossfastmake.mustke.com/qrCode/tupian/1744189130823.svg",
          type: "bar",
        },
        // {
        //   selected:
        //     "https://ossfastmake.mustke.com/qrCode/tupian/1744189184460.svg",
        //   unselected:
        //     "https://ossfastmake.mustke.com/qrCode/tupian/1744189163252.svg",
        //   type: "column",
        // },
      ],
      randomString: Date.now(),
    };
  },
  created() {},
  mounted() {
    console.log("QuestionType8888888888", this.QuestionType);
    console.log(this.$route.query.uuid, "this.$route.params.uuid");
    this.uuid = this.$route.query.uuid;
    this.getMessage();
    questionsAnalyList({
      uuid: this.uuid,
    }).then((res) => {
      if (res.code === 200) {
        this.analysisList = res.data.map((item) => {
          item.disabled = false;
          item.isSelected = false;
          item.typeSelected = ""; // 选择标识，被X选择还是被Y选中，X或Y
          return item;
        });
      }
    });
  },
  methods: {
    getMessage() {
      questionAnalysis({
        uuid: this.uuid,
      })
        .then((res) => {
          if (res.code === 200) {
            this.questionList = res.data;
          } else {
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    handleExtraClick(i) {
      this.activeIndex = i;
      if (i === 1) {
        questionnaireDataList({
          uuid: this.uuid,
          pageNum: this.currentPage,
        }).then((response) => {
          this.tableData = response.rows;
          this.total = response.total;
        });
      }
    },
    handleUserDetail(e) {
      this.dialogVisible = true;
      this.dialogData = e;
    },
    handleSurveyDetail(e) {
      console.log("e", e);
      this.$router.push({
        path: "/DataStatisticsPage/DialogDetail",
        query: {
          id: e.id,
          uuid: e.uuid,
          nickname: e.nickname,
          addTime: e.addTime,
          endTime: e.endTime,
          profilePhoto: e.profilePhoto,
        },
      });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.queryParams.pageNum = page;
      this.handleExtraClick(1);
    },
    dialogConfirm() {
      this.dialogData = {};
    },
    closeModal() {
      showModal.value = false;
      modalInput.value = "";
    },
    confirmAdd() {
      if (!modalInput.value.trim()) return;

      if (modalType.value === "independent") {
        independentVars.value.push(modalInput.value);
      } else if (modalType.value === "dependent") {
        dependentVars.value.push(modalInput.value);
      }

      closeModal();
    },
    removeIndependentVar(index) {
      independentVars.value.splice(index, 1);
    },
    removeDependentVar(index) {
      dependentVars.value.splice(index, 1);
    },
    addAnalysisVar(type) {
      this.showAnalysis = true;
      this.analysisType = type;

      if (this.analysisType === "X") {
        if (
          this.analysisList.filter(
            (item) => item.typeSelected === "X" && item.isSelected === true,
          ).length >= 2
        ) {
          this.analysisList.map((item) => {
            if (item.typeSelected === "X" && item.isSelected === true) {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
            return item;
          });
        } else {
          this.analysisList.map((item) => {
            if (item.typeSelected === "Y" && item.isSelected === true) {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
            return item;
          });
        }
      } else {
        if (
          this.analysisList.filter(
            (item) => item.typeSelected === "Y" && item.isSelected === true,
          ).length >= 10
        ) {
          this.analysisList.map((item) => {
            if (item.typeSelected === "Y" && item.isSelected === true) {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
            return item;
          });
        } else {
          this.analysisList.map((item) => {
            if (item.typeSelected === "X" && item.isSelected === true) {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
            return item;
          });
        }
      }
    },
    handleCheckboxChange(event, index) {
      console.log(event, index, event);
      this.$set(this.analysisList[index], "isSelected", event);
      this.$set(this.analysisList[index], "typeSelected", this.analysisType);
      this.$forceUpdate();
      if (this.analysisType === "X") {
        if (
          this.analysisList.filter(
            (item) => item.typeSelected === "X" && item.isSelected === true,
          ).length >= 2
        ) {
          this.analysisList.map((item) => {
            if (item.typeSelected === "X" && item.isSelected === true) {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
            return item;
          });
        } else {
          this.analysisList.map((item) => {
            if (item.typeSelected === "Y" && item.isSelected === true) {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
            return item;
          });
        }
      } else {
        if (
          this.analysisList.filter(
            (item) => item.typeSelected === "Y" && item.isSelected === true,
          ).length >= 10
        ) {
          this.analysisList.map((item) => {
            if (item.typeSelected === "Y" && item.isSelected === true) {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
            return item;
          });
        } else {
          this.analysisList.map((item) => {
            if (item.typeSelected === "X" && item.isSelected === true) {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
            return item;
          });
        }
      }
    },
    confirmAddAnalysis() {
      if (this.analysisType === "X") {
        this.analysisList_x = this.analysisList.filter((item) => {
          return item.isSelected === true && !item.disabled;
        });
      } else if (this.analysisType === "Y") {
        this.analysisList_y = this.analysisList.filter((item) => {
          return item.isSelected === true && !item.disabled;
        });
      }
      this.showAnalysis = false;
      console.log(this.analysisList);
      console.log(this.analysisList_x, this.analysisList_y);
    },
    removeAnalysisVar(type, index) {
      if (type === "X") {
        this.analysisList.map((item) => {
          if (item.id === this.analysisList_x[index].id) {
            item.isSelected = false;
            item.disabled = false;
            item.typeSelected = "";
          }
          return item;
        });
        this.analysisList_x.splice(index, 1);
        if (
          this.analysisList.filter(
            (item) => item.typeSelected === "X" && item.isSelected === true,
          ).length >= 2
        ) {
          this.analysisList.map((item) => {
            if (item.typeSelected === "X" && item.isSelected === true) {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
            return item;
          });
        } else {
          this.analysisList.map((item) => {
            if (item.typeSelected === "Y" && item.isSelected === true) {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
            return item;
          });
        }
      } else {
        this.analysisList.map((item) => {
          if (item.id === this.analysisList_y[index].id) {
            item.isSelected = false;
            item.disabled = false;
            item.typeSelected = "";
          }
          return item;
        });
        this.analysisList_y.splice(index, 1);
        if (
          this.analysisList.filter(
            (item) => item.typeSelected === "Y" && item.isSelected === true,
          ).length >= 10
        ) {
          this.analysisList.map((item) => {
            if (item.typeSelected === "Y" && item.isSelected === true) {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
            return item;
          });
        } else {
          this.analysisList.map((item) => {
            if (item.typeSelected === "X" && item.isSelected === true) {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
            return item;
          });
        }
      }
    },
    resetAnalysis() {
      this.analysisList_x = [];
      this.analysisList_y = [];
      this.analysisList.map((item) => {
        item.disabled = false;
        item.isSelected = false;
        return item;
      });
    },
    generateAnalysis() {
      crossAnalysis({
        uuid: this.uuid,
        axisX: this.analysisList_x.map((item) => item.id),
        axisY: this.analysisList_y.map((item) => item.id),
      }).then((res) => {
        console.log(res, "res1111111111");

        if (res.code === 200) {
          // this.analysisResult = res.data;
          this.chartOptions = [];
          const yaxisList = res.data.crossAnalysis.yaxisList;
          for (let i = 0; i < yaxisList.length; i++) {
            this.chartOptions.push({
              title: yaxisList[i].questionTitle,
              id: `chart-${Date.now()}-${i}`,
              type: "line",
              xaxis: res.data.crossAnalysis.xaxis,
              yAxis: yaxisList[i],
              option: this.handleChartDataLine(
                res.data.crossAnalysis.xaxis,
                yaxisList[i],
              ),
            });
          }
          console.log(this.chartOptions, "this.chartOptions");
        }
      });
    },
    handleChartDataLine(xaxis, yAxis) {
      let series = [];
      for (let j = 0; j < yAxis.matrix.length; j++) {
        // yAxis.matrix[j]
        const element = {
          name: yAxis.options.map((item) => item.text)[j],
          type: "line",
          stack: "Total",
          data: yAxis.matrix[j].map((item) => (item.count ? item.count : 0)),
        };
        series.push(element);
      }
      return {
        title: {
          // text: "Stacked Line",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: yAxis.options.map((item) => item.text),
          bottom: 0, // 距离底部 10px（关键配置）
          // 可选：水平居中显示（更美观）
          left: "center",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xaxis.options.map((item) => item.text),
          axisLabel: {
            color: "#7B818A",
            fontSize: 14,
          },
        },
        yAxis: {
          type: "value",
        },
        series: series,
      };
    },
    handleChartDataBar(xaxis, yAxis) {
      let series = [];
      for (let j = 0; j < yAxis.matrix.length; j++) {
        const element = {
          name: yAxis.options.map((item) => item.text)[j],
          type: "bar",
          stack: "total",
          barWidth: "40%",
          label: {
            show: true,
          },
          data: yAxis.matrix[j].map((item) => (item.count ? item.count : "")),
        };
        series.push(element);
      }
      return {
        legend: {
          selectedMode: false,
        },
        yAxis: {
          type: "value",
        },
        xAxis: {
          type: "category",
          data: xaxis.options.map((item) => item.text),
        },
        series: series,
      };
    },
    handleTableData() {},
    drawChart(icon, index) {
      this.chartOptions[index].type = icon.type;
      this.chartOptions[index].id = `chart-${Date.now()}-${index}`;
      if (icon.type === "line") {
        this.chartOptions[index].option = this.handleChartDataLine(
          this.chartOptions[index].xaxis,
          this.chartOptions[index].yAxis,
        );
      }
      if (icon.type === "bar") {
        this.chartOptions[index].option = this.handleChartDataBar(
          this.chartOptions[index].xaxis,
          this.chartOptions[index].yAxis,
        );
      }
      if (icon.type === "column") {
      }
    },
  },
};
</script>

<style scoped>
.buttonList {
  height: 52px;
  line-height: 52px;
  background-color: #f1f3f7;
  display: flex;

  .item {
    margin-right: 10px;
    padding: 0;
    width: 220px;
    height: 52px;
    line-height: 52px;
    text-align: center;
    background-color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    position: relative;
    cursor: pointer;

    &::before {
      display: none;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 5px;
      background-color: #1e80ff;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }

    &.active {
      color: #409eff;

      &::before {
        display: block;
      }
    }
  }
}

.dataAnalysis {
  padding: 20px;
  background: #fff;
  margin: 20px;

  .tableSpan {
    font-size: 14px;
    color: #1e80ff;
    cursor: pointer;
    margin: 0 5px;
  }
}

.my-custom-dialog .el-dialog__header,
.my-custom-dialog .el-dialog__body,
.my-custom-dialog .el-dialog__footer {
  display: none !important;
}

.dialog {
  width: 350px;
  padding: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  .profilePhoto {
    img {
      width: 90px;
      height: 90px;
      border-radius: 90px;
    }
  }

  .item {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .text {
      width: calc(100% - 120px);
      text-align: center;
    }
  }

  button {
    background-color: #579fff;
    border-color: #579fff;
    color: #fff;
    font-size: 12px;
    border-radius: 3px;
    padding: 10px 26px;
    margin-top: 30px;
    cursor: pointer;
  }
}

.close {
  position: absolute;
  top: 22px;
  right: 22px;
  width: 16px;
  height: 16px;
  cursor: pointer;

  &::before {
    display: block;
    content: "";
    width: 100%;
    height: 1px;
    background: #909399;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::after {
    display: block;
    content: "";
    width: 100%;
    height: 1px;
    background: #909399;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
  }
}

.close:hover {
  &::before {
    background: #409eff;
  }

  &::after {
    background: #409eff;
  }
}

.analysis-container {
  /* border: 2px solid #2563eb;
  padding: 24px; */
  /* border-radius: 8px; */
  width: 600px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.variable-section {
  margin-bottom: 24px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
}

.section-limit {
  font-size: 12px;
  color: #999;
  margin-left: 8px;
}

.empty-state {
  color: #999;
  font-size: 14px;
  text-align: center;
  padding: 8px 0;
}

.variable-list {
  border-top: 1px solid #e8e8e8;
}

.variable-item {
  display: flex;
  align-items: center;
  height: 49px;
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}

.delete-btn {
  /* padding: 4px 12px;
  font-size: 12px;
  color: #ef4444;
  background: none;
  border: 1px solid #ef4444;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.2s; */
  /* width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  background-color: #f46969;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px; */
  width: 18px;
  height: 18px;
  background: #f46969;
  border-radius: 50%;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-icon {
  width: 9px;
  height: 2px;
  background: #ffffff;
}

.variable-text {
  flex: 1;
  font-size: 15px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: Medium;
  text-align: left;
  color: #323b5a;
  margin-left: 12px;
  /* 超出部分省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .delete-btn:hover {
  background-color: #fef2f2;
} */

.add-btn {
  width: 100%;
  padding: 12px;
  font-size: 14px;
  color: #2563eb;
  background: none;
  border: 1px solid #2563eb;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
}

.add-btn:hover:not(:disabled) {
  background-color: #eff6ff;
}

.add-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.add-div {
  display: flex;
  align-items: center;
  /* border: 1px solid #e8e8e8; */
  border-bottom: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  height: 49px;
}

.plus-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #3a60ff;
  color: #3a60ff;
  /* background: #3a60ff; */
  margin-left: 16px;

  p {
    font-size: 12px;
  }
}

.add-text {
  width: 77px;
  height: 21px;
  font-size: 15px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: Medium;
  text-align: left;
  color: #323b5a;
  line-height: 21px;
  margin-left: 12px;
}

.analyze-btn {
  flex: 1;
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  color: white;
  background-color: #2563eb;
  border: 1px solid #2563eb;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.reset-btn {
  flex: 1;
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  color: #2563eb;
  background-color: white;
  border: 1px solid #2563eb;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 12px;
}

.analyze-btn:hover:not(:disabled) {
  background-color: #1d4ed8;
}

.analyze-btn:disabled {
  background-color: #bfdbfe;
  cursor: not-allowed;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  min-width: 300px;
}

.modal-content h3 {
  margin-bottom: 16px;
  font-size: 16px;
  color: #1f2937;
}

.modal-content input {
  width: 100%;
  padding: 10px;
  margin-bottom: 16px;
  font-size: 14px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
}

.modal-content input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.modal-buttons {
  display: flex;
  gap: 12px;
}

.btn-cancel,
.btn-confirm {
  flex: 1;
  padding: 10px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel {
  background-color: #f3f4f6;
  color: #1f2937;
}

.btn-cancel:hover {
  background-color: #e5e7eb;
}

.btn-confirm {
  background-color: #2563eb;
  color: white;
}

.btn-confirm:hover {
  background-color: #1d4ed8;
}

/* 结果显示 */
.result-section {
  margin-top: 24px;
  padding: 12px;
  background-color: #ecfdf5;
  border-left: 4px solid #10b981;
  border-radius: 4px;
}

.result-section h4 {
  font-size: 14px;
  color: #047857;
  margin-bottom: 8px;
}

.result-section p {
  font-size: 13px;
  color: #059669;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1009;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1009;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  width: 600px;
  /* height: 600px; */
  background: #ffffff;
  z-index: 1009;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

.header {
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;

  p {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: 600;
  }

  i {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}

.analy-btn {
  width: 100%;
  display: flex;
  border-top: 1px solid #e7e7e7;

  .analy-cancel {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    background: none;
    cursor: pointer;
    height: 51px;
  }

  .analy-confirm {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    background: #2563eb;
    cursor: pointer;
    height: 51px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DataStatisticsPage/DataDetail/index.vue